import { use } from 'react';
import { StoreDetailClient } from './store-detail-client';

export const metadata = { title: 'Store · Admin' };

export default function Page({ params }: { params: Promise<{ id: string }> }) {
  const { id } = use(params);
  return <StoreDetailClient storeId={id} />;
}
